import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  positionFixed: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1100,
  },
  button: {
    minWidth: 'auto',
  },
});

export default useStyles;
